import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { resetPassword } from '../api/auth';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [errors, setErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate('/forgot-password');
    }
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setIsLoading(true);
    try {
      await resetPassword({
        token,
        password,
        password_confirmation: passwordConfirmation
      });
      navigate('/signin');
    } catch (err) {
      const apiErrors = err.response?.data?.errors;
      setErrors(Array.isArray(apiErrors) ? apiErrors : [err.response?.data?.error || 'Something went wrong']);
    } finally {
      setIsLoading(false);
    }
  };

  if (!token) return null;

  return (
    <div className="auth-page">
      <div className="auth-form-container">
        <h1>Reset Password</h1>
        <form onSubmit={handleSubmit} className="auth-form">
          {errors.length > 0 && (
            <div className="error-messages">
              <ul>
                {errors.map((err, i) => <li key={i}>{err}</li>)}
              </ul>
            </div>
          )}
          <div className="form-group">
            <label htmlFor="password">New Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              autoComplete="new-password"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password_confirmation">Confirm Password</label>
            <input
              type="password"
              id="password_confirmation"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              required
              minLength={6}
              autoComplete="new-password"
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={isLoading}>
            {isLoading ? 'Resetting...' : 'Reset password'}
          </button>
        </form>
        <p className="auth-switch">
          <Link to="/signin">Back to Sign In</Link>
        </p>
      </div>
    </div>
  );
}

export default ResetPassword;
